/** Initial nested state for Contract Manufacturer public RFQ (matches UI sections). */

export const emptyProductRow = () => ({
  filters: '',
  partName: '',
  partNumber: '',
  rev: '',
  uom: '',
  quantity: '',
  material: '',
});

export const emptyTierRow = () => ({
  tierLabel: 'Tier 1',
  minQuantity: '',
  unitPrice: '',
  currency: 'USD',
  remarks: '',
});

export function getInitialRfqForm() {
  return {
    business: {
      companyName: '',
      contactName: '',
      email: '',
      phone: '',
      technicalContact: '',
      commercialContact: '',
      preferredCommunication: '',
    },
    project: {
      title: '',
      manufacturingProcessFacilities: '',
      expectedStartDate: '',
      frequencyOfManufacturing: '',
      estimatedOrderVolume: '',
      estimatedAnnualUsage: '',
      lifetimeVolume: '',
      targetCost: '',
      industryType: '',
      ndaRequired: '',
    },
    products: [emptyProductRow()],
    technical: {
      materialsDetail: '',
      hardnessTarget: '',
      ndt: '',
      resinPolymerGrade: '',
      colourCode: '',
      targetShelfLifeMonths: '',
      heatTreatment: '',
      coatingSurfaceFinish: '',
      weldingRequirement: '',
      pcbStackupFinish: '',
      cleanRoomClass: '',
      toolingModuleDetails1: '',
      toolingModuleDetails2: '',
      showMoreTechnical: false,
    },
    quality: {
      certificateRequired: '',
      regulatoryClaims: '',
      acceptableQualityLevel: '',
      inspectionRequiredDocument: '',
      testMethodsStandards: '',
    },
    packaging: {
      packagingSpecification: '',
      shipToCountryPostcode: '',
      labellingBarcoding: '',
      preferredTransport: '',
      coldChain: true,
      packagingTestMethods: '',
    },
    commercial: {
      preferredPricingModel: '',
      paymentMethod: '',
      unitOfMeasurement: '',
      paymentTerms: '',
      incoterms: '',
      priceEscalationClause: '',
      addOnCategories: '',
      toolingOwnership: '',
      jurisdiction: '',
      priceValidityDays: '',
      liquidatedDamages: '',
      toolingNre: '',
      deliveryMethods: '',
      portOfShipping: '',
      expectedDispatchDate: '',
      priceNegotiable: true,
      toolingNrePossible: true,
    },
    basePrice: {
      price: '',
      currency: 'USD',
      moq: '',
      cgst: '',
      sgst: '',
      igst: '',
      cess: '',
      vat: '',
      otherTaxes: '',
    },
    tierBreaks: [emptyTierRow()],
    sample: {
      sampleOffered: true,
      sampleType: '',
      sampleCost: '',
      samplePrice: '',
      sampleCurrency: 'USD',
      dispatchLeadTimeDays: '',
      sampleShippingMode: '',
      sampleReturnPolicy: '',
      sampleRemarks: '',
      warranty: '',
      warrantyPeriod: '',
      warrantyRemarks: '',
      guarantee: '',
      guaranteePeriod: '',
      guaranteeRemarks: '',
    },
    attachmentsMeta: {
      nda: null,
      specification: null,
      packagingArtwork: null,
      other: null,
    },
    technicalFiles: {
      formulaRecipe: null,
      pcbDocs: null,
      ingredientBom: null,
    },
    declarations: {
      terms: false,
      compliance: false,
    },
  };
}

export const YES_NO = [
  { value: '', label: 'Select…' },
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' },
];

export const COMM_PREFS = [
  { value: '', label: 'Select…' },
  { value: 'Email', label: 'Email' },
  { value: 'Phone', label: 'Phone' },
  { value: 'WhatsApp', label: 'WhatsApp' },
  { value: 'Platform messaging', label: 'Platform messaging' },
];

export const CURRENCIES = ['USD', 'INR', 'EUR', 'GBP', 'AED'];
